module.exports = __webpack_public_path__ + "media/styles/images/svg/oval-gray-dark-c887e7a60d1a328d2bce075fdb5dba0c.svg";